import {
  editableLoanQuoteStatuses,
  LoanQuoteStatus,
} from '@axo/shared/data-access/types/loan_quote';

export function isLoanQuoteStatusEditable(loanQuoteStatus: LoanQuoteStatus) {
  return (
    !loanQuoteStatus || editableLoanQuoteStatuses.includes(loanQuoteStatus)
  );
}

export function selectableLoanQuoteStatusOptions(
  loanQuoteStatus: LoanQuoteStatus
) {
  if (!loanQuoteStatus)
    return [LoanQuoteStatus.ApplicationRegisteredPendingBankDecision];
  switch (loanQuoteStatus) {
    case LoanQuoteStatus.ApplicationRegisteredPendingBankDecision:
      return [LoanQuoteStatus.ApplicationRegisteredApprovedByBank];
    case LoanQuoteStatus.ApplicationApprovedPendingCustomerDecision:
      return [
        LoanQuoteStatus.ApplicationApprovedAcceptedByCustomer,
        LoanQuoteStatus.ApplicationApprovedAcceptedByAxo,
        LoanQuoteStatus.ApplicationApprovedRejectedByBank,
      ];
    case LoanQuoteStatus.ApplicationApprovedAcceptedByCustomer:
    case LoanQuoteStatus.ApplicationApprovedAcceptedByAxo:
      return [LoanQuoteStatus.OfferAcceptedPendingBankDisbursementDecision];
    case LoanQuoteStatus.OfferAcceptedPendingBankDisbursementDecision:
      return [
        LoanQuoteStatus.LoanApprovedForDisbursementPendingDisbursement,
        LoanQuoteStatus.OfferAcceptedNotApprovedForDisbursementByBank,
      ];
    case LoanQuoteStatus.LoanApprovedForDisbursementPendingDisbursement:
      return [LoanQuoteStatus.LoanApprovedForDisbursementDisbursedByBank];
    default:
      return [LoanQuoteStatus.ApplicationRegisteredPendingBankDecision];
  }
}
